
import { Vue, Options } from "vue-class-component";
import { Emit, Model, Prop, Watch } from "vue-property-decorator";
import { ElMessage } from "element-plus";
import MiezzPageList from "@/models/MiezzPageList";
import DtoPageListSearchOrderPoolTrunk from "@/models.machine/DtoPageListSearchOrderPoolTrunk";
import DtoListItemOrderPoolTrunk from "@/models.machine/DtoListItemOrderPoolTrunk";
import TrunkPageList from "./TrunkPageList.vue";
import { MiezzMenuTab } from "@/components/MiezzMenuTab.vue";
import { EnumOrderServiceType } from "@/models.machine/EnumOrderServiceType";
@Options({
  components: {
    TrunkPageList,
  },
})
export default class DestinationPortTrunkPageList extends Vue {
  menuTab = new MiezzMenuTab();
  list = new MiezzPageList<
    DtoPageListSearchOrderPoolTrunk,
    DtoListItemOrderPoolTrunk,
    string
  >("OrderManagement_Pool_Summary_DestinationPortTrunk");
  powers: string[] = [];
  serviceType = EnumOrderServiceType.DestinationPort;

  created(): void {
    this.menuTab.Back = true;
    this.menuTab.Url = `/order/pool/destination-port-trunk/${this.$route.params.id}`;
    this.menuTab.Menus = [
      {
        Label: "目的港-干线物流",
        Url: `/order/pool/destination-port-trunk/${this.$route.params.id}`,
        Power: "OrderManagement_Pool_Summary_DestinationPortTrunk",
      },
    ];
  }
}
